import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-doctors-next-forgot-password',
  templateUrl: './doctors-next-forgot-password.component.html',
  styleUrls: [
    './doctors-next-forgot-password.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
